/**
 * Mobile Menu Click Events
 */
function mobileMenu (): void {
  const mobileMenu = document.querySelector<HTMLDivElement>('.mobile-menu')
  

  if (!mobileMenu) {
    return
  }
  
  const menuButton = document.querySelector('.menu-button ')
  const parents = mobileMenu.querySelectorAll('.has-children')

  parents.forEach(parent => {
    let dropdown = parent.querySelector('.mobile-dropdown');
    let parentLink = parent.querySelector('.parent-link');
    let backLink = dropdown?.querySelector('.back-link');

    parentLink?.addEventListener('click', () => {
      parentLink.classList.add('parent-open')
    })

    backLink?.addEventListener('click', () => {
      parentLink?.classList.remove('parent-open')
    })
  })

  menuButton?.addEventListener('click', ()=> {
    let openParents = document.querySelectorAll('.parent-open')
    if (openParents) {
      openParents.forEach(openParent => {
        openParent.classList.remove('parent-open')
      })
    }
  })
}

export { mobileMenu }
